import React from 'react';
import { Button } from 'antd';
import useDownloadLlmVisibilityPdf from '../../reportRenderEngine/hooks/useDownloadLlmVisibilityPdf';
import { ModelFamily } from '../types';

type Props = {
    domain: string;
    modelFamily: ModelFamily;
    disabled: boolean;
};

export default function DownloadPdfButton({ domain, modelFamily, disabled }: Props) {
    const { downloadPdf, isDownloadingPdf } = useDownloadLlmVisibilityPdf();

    return (
        <Button
            className="download-pdf-button"
            size="small"
            disabled={disabled || isDownloadingPdf}
            icon={isDownloadingPdf ? 'loading' : 'file-pdf'}
            onClick={() => downloadPdf(domain, modelFamily)}
        >
            Download PDF
        </Button>
    );
}
